import React from 'react'

export const FinanceReportPage = React.lazy(() => import('./finance-report.page'))

export const TermGSTPage = React.lazy(() => import('./term-gst.page'))
